import {Fragment, useContext, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {EntityContext} from "../../context/EntityContext";
import {Amplify} from 'aws-amplify';
import config from '../../amplifyconfiguration.json';
import { MdContentCopy } from "react-icons/md";
import { IoCheckmarkSharp} from "react-icons/io5";
import {TfiClose} from "react-icons/tfi";


Amplify.configure(config);


export default function Delete() {

    const cancelButtonRef = useRef(null)
    const {openShareMapsLink,setOpenShareMapsLink, currentEntity} = useContext(EntityContext);
    const [copyLink1, setCopyLink1] = useState(false);
    const [copyLink2, setCopyLink2] = useState(false);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const escapeHtml = (str) => {
        if(typeof str !== "undefined") {
            var a =  str.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');

            return '<iframe src="'+a+'" width="100%" height="1080px"></iframe>';
        }
        return str;
    };


    return (
        <Transition.Root show={openShareMapsLink} as={Fragment}>
            <Dialog className="relative z-10" initialFocus={cancelButtonRef} onClose={(e) => {setOpenShareMapsLink(e); setCopyLink1(false); setCopyLink2(false);} }>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >

                            <Dialog.Panel className='flex max-w-xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => {setOpenShareMapsLink(false); setCopyLink1(false); setCopyLink2(false);}}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className={' flex flex-col w-full'}>
                                        <Dialog.Title
                                            as='h3'
                                            className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                                            Karten-Link kopieren
                                        </Dialog.Title>
                                        <div className='p-8 flex flex-col flex-1  overflow-y-auto'>
                                            <p className="text-sm my-2  text-gray-600">
                                                Sie können nun den folgenden Link kopieren:
                                            </p>

                                            <pre className="text-sm rounded-md bg-gray-300  relative my-2 p-4 pb-8 text-gray-600" >
                                                    https://app.xplanung24.de/integration/maps/{currentEntity?.accessId}
                                                <div onClick={()=>{ copyToClipboard("https://app.xplanung24.de/integration/maps/"+currentEntity?.accessId); setCopyLink1(true) } } className={(copyLink1 === false)? "p-2 ring-gray-500 right-2 bottom-2 cursor-pointer rounded-md absolute ring-1  hover:text-white hover:bg-gray-900" :"p-2 ring-gray-500 right-2 bottom-2 cursor-pointer rounded-md absolute ring-1  text-white bg-gray-900"}>{(copyLink1 === false) ? <MdContentCopy/> : <IoCheckmarkSharp  />}</div>
                                                </pre>


                                            <p className="text-sm my-2  text-gray-600">
                                                oder als Iframe in eine bestehende HTML Webseite einsetzen
                                            </p>
                                            <pre className="text-sm rounded-md bg-gray-300  relative my-2 p-4 pb-8 text-gray-600" >
                                                    {escapeHtml("https://app.xplanung24.de/integration/maps/"+currentEntity?.accessId)}
                                                <div onClick={()=>{ copyToClipboard(escapeHtml("https://app.xplanung24.de/integration/maps/"+currentEntity?.accessId)); setCopyLink2(true) } } className={(copyLink2 === false)? "p-2 ring-gray-500 right-2 bottom-2 cursor-pointer rounded-md absolute ring-1  hover:text-white hover:bg-gray-900" :"p-2 ring-gray-500 right-2 bottom-2 cursor-pointer rounded-md absolute ring-1  text-white bg-gray-900"}>{(copyLink2 === false) ? <MdContentCopy/> : <IoCheckmarkSharp  />}</div>
                                                </pre>


                                            <p className="text-sm my-2  text-gray-600">
                                                oder rufen Sie die dargestellten Karteninhalte als WFS ab.
                                            </p>
                                            <pre className="text-sm rounded-md bg-gray-300 relative my-2 p-4 pb-4 text-gray-600" >
                                                    Auf Anfrage

                                            </pre>

                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>

                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
